import { useEffect, useState } from 'react';
import { css, keyframes, styled } from 'styled-components';
import Cookies from 'js-cookie';
import { Assets, BaseLink, Box, Flex, NoStyleButton, ResponsiveSpacing, Text, theme } from '@foradevelopment/fora-ui';

const StyledText = styled(Text)`
  @media screen and (min-width: ${theme.breakpoint.lg}px) {
    display: inline-block;
  }
`;

type CookieBannerProps = {
  showBannerDelayMs: 2000 | 5000;
  domain: string;
  contentWidth: ResponsiveSpacing;
};

const COOKIE_INFO_CLOSED = 'cookie_info_closed';

export const CookieBanner = ({ showBannerDelayMs, domain, contentWidth }: CookieBannerProps) => {
  const [showBanner, setShowBanner] = useState<boolean>(false);

  useEffect(() => {
    const cookieValue = Cookies.get(COOKIE_INFO_CLOSED);
    if ((!showBanner && !cookieValue) || process.env.STORYBOOK) {
      setTimeout(() => {
        setShowBanner(true);
      }, showBannerDelayMs);
    }
  }, [showBanner, showBannerDelayMs]);

  const handleCloseBanner = () => {
    if (!process.env.STORYBOOK) {
      const date = new Date();
      date.setFullYear(date.getFullYear() + 2);
      Cookies.set(COOKIE_INFO_CLOSED, 'true', {
        expires: date,
        path: '/',
        domain: domain,
        secure: false,
      });
      setShowBanner(false);
    }
  };

  return (
    <StyledFlex
      showBanner={showBanner}
      backgroundColor="black"
      justifyContent="space-around"
      width="100%"
      position="fixed"
      textAlign="center"
      paddingTop={[10, 20, 20]}
      paddingBottom={[10, 20, 20]}
      paddingLeft={[20]}
      paddingRight={[20]}
    >
      {showBanner && (
        <Flex justifyContent={'space-between'} width={contentWidth}>
          <Box textAlign="left">
            <StyledText color="white">
              Vi använder nödvändiga cookies för att du som besökare ska kunna använda webbplatsen.{' '}
            </StyledText>
            <BaseLink
              variant="transparent"
              to="https://fora.se/cookies"
              style={{ textDecoration: 'underline', textDecorationColor: 'white' }}
              hasIcon={false}
            >
              Läs mer om vilka cookies webbplatsen använder
            </BaseLink>
          </Box>
          <NoStyleButton color="white" onClick={handleCloseBanner} title="Stäng">
            <Assets.MenuCloseIcon />
          </NoStyleButton>
        </Flex>
      )}
    </StyledFlex>
  );
};

const slideIn = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const slideOut = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
`;

const StyledFlex = styled(Flex)<{ showBanner: boolean }>`
  bottom: 0;
  z-index: ${theme.zIndex.overlay + 1};
  animation: ${props =>
    props.showBanner
      ? css`
          ${slideIn} 0.5s ease-out forwards
        `
      : css`
          ${slideOut} 0.1s ease-out forwards
        `};
`;
